import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { HistoryRuleGroupUpdateDetailsRow } from "../views/historyRuleGroupDetailsViewConfig";

export const HistoryRuleGroupModifiedCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        HistoryRuleGroupUpdateDetailsRow,
        HistoryRuleGroupUpdateDetailsRow["modified"]
    >) => {
        const { modified } = row.original;

        return (
            <ViewTableCell>
                <BreakableText text={modified} showTooltip />
            </ViewTableCell>
        );
    },
);

HistoryRuleGroupModifiedCell.displayName = "HistoryRuleGroupModifiedCell";
